import { UserData } from "@/data/interfaces/UserDataInterface";
import api from "./config";

export default {
  signIn: async (params: { username: string; password: string }) => {
    const { data } = await api.post("/api/users/login", params);
    return data;
  },

  get: async (id: string) => {
    const response = await api.get(`/api/users/${id}`);
    return response.data;
  },

  save: async (user: UserData) => {
    const response = await api.post("/api/users", user);
    return response.data;
  },

  edit: async (id: string, user: UserData) => {
    const { data } = await api.patch(`/api/users/${id}`, user);
    return data;
  },

  delete: async (id: string) => {
    await api.delete(`/api/users/${id}`);
  },

  resetPassword: async (user: UserData) => {
    return await api.post(`/api/users/reset-password/${user.code}`, user);
  },

  reset: async (username: string) => {
    return await api.post(`/api/users/${username}/reset-request`);
  },

  checkCode: async (code: string) => {
    return await api.post(`/api/users/verify-otp-token`, { idToken: code });
  },
};
